import * as React from "react";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import Typography from "@mui/material/Typography";
import TopicIcon from "@mui/icons-material/Topic";
import { Link } from "react-router-dom";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import { useUserFetch } from "../api/fetch";
import Alert from "@mui/material/Alert";
import SanitizedMessage from '../components/SanitizedMessage';
import { LecturePeriod } from "../components/LecturePeriod";
import { SectionTitle } from "../components/Typography";
import { PageLayout } from "../components/layout/PageLayout";
import { AlertManager, useAlerts } from '../components/user/AlertManager';
import { usePlaybackWindow } from '../hooks/usePlaybackWindow';

export default function MyPage() {
  const [lectureData, setLectureData] = useState<any[]>([]);
  const [warningMessages, setWarningMessages] = useState<string[]>([]);
  const { setAlert, getAlertConfigs } = useAlerts();

  const { get } = useUserFetch();
  const { fetchPlaybackWindow } = usePlaybackWindow();

  useEffect(() => {
    // 深夜時間帯かどうかはサーバ(JST)の判定を使う(端末の時計に依存させない)。
    // 文言もサーバ生成のもの(時間帯入り)を表示し、動画一覧側の表示と一致させる。
    fetchPlaybackWindow().then((playbackWindow) => {
      if (playbackWindow?.blocked) {
        setAlert('lateNightAlert', true, playbackWindow.message);
      }
    });

    const fetchLectures = get<{ message: string; lectures: any[] }>("/api/user/lectures");
    const fetchWarningMessage = get<{ messages: string[] }>("/api/user/warning");

    Promise.all([fetchLectures, fetchWarningMessage])
      .then(([lectureRes, warningMessageRes]) => {
        console.log(lectureRes.message);
        setLectureData(lectureRes.lectures);
        setWarningMessages(warningMessageRes.messages);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <AlertManager alerts={getAlertConfigs()} />
      <PageLayout
        header={{
          title: "マイページ"
        }}
        body={
          <>
            {warningMessages.map((msg, idx) => (
              <Alert
                key={msg}
                severity="warning"
                sx={{ mr: 4, ml: 4, mt: idx === 0 ? 0 : 2 }}
              >
                <SanitizedMessage message={msg} />
              </Alert>
            ))}
            <Grid spacing={1}>
              <Card
                variant="outlined"
                sx={{ mt: 2, mr: 4, ml: 4, borderRadius: "20px" }}
              >
                <CardContent>
                  <SectionTitle title="講座一覧" />
                  {Lectures(lectureData)}
                </CardContent>
              </Card>
            </Grid>
          </>
        }
      />
    </>
  );
}

function Lectures(lectureData: any[]) {
  if (!lectureData || lectureData.length === 0) {
    return (
      <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
      }}>
        受講可能な講座はありません
      </div>);
  }

  return (
    <List sx={{ bgcolor: "grey.200" }}>
      {lectureData.map((row: any) => (
        <ListItem key={row.id} disablePadding>
          <ListItemButton
            component={Link}
            to={"/lecture/" + row.id}
          >
            <TopicIcon sx={{ mr: 1 }} />
            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              flexGrow: 1,
              justifyContent: 'space-between', // 左右に分ける
              width: '100%' // 幅いっぱいに広げる
            }}>
              <Typography>{row.lectureName}</Typography>
              <LecturePeriod
                startAt={row.startAt}
                endAt={row.endAt}
                sx={{ ml: 'auto' }} />
            </Box>
            <KeyboardArrowRightIcon sx={{ ml: 2 }} />
          </ListItemButton>
        </ListItem>
      ))}
    </List>);
}

